import { IForm } from "c8-platform";
import csi from "csi/main";
import New from "csi/table/New";
import { cnl } from "csi/typings";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import _ from "lodash";

const NewProjectLineItemController = declare(New, {

	/*
	 * @override
	 * Navigate to project LineItem's product node
	 */
	_getNavigateNodeURL(): cnl {
		return this.getNode().Product;
	},

	/**
	 * @override
	 * Handle Project "New Food" and "New FormulatedMaterial" actions (C8-49326).
	 */
	onCreateFormInfo(formInfo: IForm): void {
		const nodeType = formInfo?.nodeType;
		if (nodeType === "Food" || nodeType === "FormulatedMaterial" || nodeType === "Material") {
			formInfo.parentUrl = csi.EMPTY_URL;
		}
		this.inherited(arguments);
	},

	/*
	 * @override
	 * Changing the URL for the changedNode Operations to be executed on.
	 * In this case Product(Food/Material) under the Project.ProjectLineItem.
	 */
	toWriterFields(urlNode: cnl): void {
		this.inherited(arguments, [xml.getUrlPath(urlNode, "Child:Product")]);
	},

	toWriterRequest(): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		const nodeType = this.getActionNodeType();

		if (nodeType === "Food" || nodeType === "FormulatedMaterial") {
			const fd = this.m_formData;
			const lastField = fd.getFields().pop();

			const subRecipeName = fd.getFieldValue("RecipeDataSheet/Node Name", true);
			const subRecipeType = fd.getFieldValue("RecipeDataSheet/Subtype", true);
			if (nodeType === "FormulatedMaterial" && subRecipeType && subRecipeName) {
				call.addParameter("Recipe Name", xml.ATTR_STRING, subRecipeName);
				call.addParameter("Recipe Subtype", xml.ATTR_STRING, subRecipeType);
			}
			if (nodeType === "Food") {
				const autoCreateSKUValue = fd.getFieldValue("AutoCreateSKU", true);
				call.addParameter("AutoCreateSKU", xml.ATTR_BOOLEAN, autoCreateSKUValue);
			}
			call.addParameter("ProductHierarchyFolder", xml.ATTR_REF, lastField.getValue());

			_.forEach(fd.getFields(), (field) => {
				const fieldId = field.idParameter || field.m_id;
				if (fieldId && !field.m_bUsed) {
					call.addGeneralizedParameter(fieldId, field.getType(), field.getValue());
					field.m_bUsed = true;
				}
			});
		}

		return call;
	},

	/**
	 * @override
	 * Validate new Product created in addition to new ProjectLineItem.
	 */
	validateNode(url: cnl, bWithAttributes: boolean) {
		this.inherited(arguments);
		this.m_writer.validateNode(`${url}?Path=Child:Product`, bWithAttributes);
	},

});

export = NewProjectLineItemController;